import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { UpdateDashboardNoteCommand, UpdateDashboardNoteCommandHandlerBase, UpdateDashboardNoteResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(UpdateDashboardNoteCommand)
@Injectable({ providedIn: 'root'})
export class UpdateDashboardNoteCommandHandler {
    private commandHandler: UpdateDashboardNoteCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new UpdateDashboardNoteCommandHandlerBase(http);
    }

    public async handleAsync(cmd: UpdateDashboardNoteCommand): Promise<UpdateDashboardNoteResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
